import { darken } from "polished";
import styled from "styled-components";

export const AnswerWrapper = styled.button`
  max-width: 590px;
  width: 48%;
  min-width: 460px;
  background: ${(props) => (props.selected ? "#BEE8ED" : "#4d5e60")};
  padding: 8px 32px;
  margin-bottom: 16px;
  border: none;
  text-align: left;
  cursor: pointer;

  :hover {
    background: ${darken(0.2, "#4d5e60")};
    div p {
      color: white;
    }
  }

  ::before {
    content: "${(props) => props.number}";
    display: inline;
    border-right: 1px solid currentColor;
    padding-right: 8px;
    color: ${(props) => (props.selected ? "#4d5e60" : "white")};
    ${(props) => props.selected && "font-weight: 600;"};
  }

  :disabled,
  :disabled :hover {
    cursor: default;
    background: ${(props) =>
      props.selected ? (!props.correct ? "#f44336" : "#4caf50") : "#4d5e60"};
  }
`;

export const AnswerContent = styled.div`
  display: inline-block;
  padding-left: 8px;
  p {
    color: ${(props) => (props.selected ? "#4d5e60" : "white")};
    ${(props) => props.selected && "font-weight: 600;"};
  }
`;

export const AnswerImage = styled.img`
  max-width: 100%;
  height: auto;
  display: block;
  border: solid 2px;
`;
